import { DIRECT_SIGNUP_MIXPANEL_EVENTS } from 'domains/signupDirect/misc/mixpanelTracking';
import { TimeRange } from 'domains/signupDirect/misc/constants';

type TrackFunction = (event: string) => void;

const optionToEventKeyMap: Record<TimeRange, keyof typeof DIRECT_SIGNUP_MIXPANEL_EVENTS.TIME_OPTIONS> = {
  earlyMorning: 'EARLY_MORNING',
  morning: 'MORNING',
  afternoon: 'AFTERNOON',
  evening: 'EVENING',
};

/**
 * Tracks time options selection in Mixpanel
 * @param timeOptions - The time options selected by the user (undefined if feature is disabled)
 * @param track - Mixpanel track function
 */
export const trackTimeOptionsSelection = (timeOptions: TimeRange[] | undefined, track: TrackFunction) => {
  if (!timeOptions) {
    // Track when checkboxes are not shown (feature flag is off)
    track(DIRECT_SIGNUP_MIXPANEL_EVENTS.TIME_OPTIONS.FEATURE_DISABLED);
    return;
  }

  // Check if any option is selected
  const hasAnySelection = timeOptions.length > 0;

  if (!hasAnySelection) {
    // Track when user submits without selecting any checkbox
    track(DIRECT_SIGNUP_MIXPANEL_EVENTS.TIME_OPTIONS.NO_SELECTION);
    return;
  }

  // Track each selected option
  timeOptions.forEach(optionKey => {
    if (optionToEventKeyMap[optionKey]) {
      const eventKey = optionToEventKeyMap[optionKey];
      const mixpanelEvent = DIRECT_SIGNUP_MIXPANEL_EVENTS.TIME_OPTIONS[eventKey];
      if (mixpanelEvent) {
        track(mixpanelEvent);
      }
    }
  });
};
